import { styled } from 'styled-components'

export const StyledContainer = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;

  /* @media (max-width: ${({ theme }) => theme.screen.small}) {
    flex-direction: column;
  } */
`

export const StyledIcon = styled.img`
  margin: 0 0 0 -3em;
  width: 220px;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    margin: 0 -0.6em 0 -1.8em;
    width: 120px;
  }
`

export const StyledTextContainerMain = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1em 0 0 0;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    margin: 0.6em 0 0 0;
  }
`

export const StyledTextContainerOne = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.6em;
  justify-content: center;
  align-content: center;
  flex: 1;
`

export const StyledLineOne = styled.div`
  font-family: ${({ theme }) => theme.fonts.title.lineOne};
  font-size: 3em;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    font-size: 1.6em;
  }
`

export const StyledTextContainerTwo = styled(StyledTextContainerOne)`
  gap: 1.4em;
  flex: 1;
  
  @media (max-width: ${({ theme }) => theme.screen.small}) {
    gap: 1em;
  }
`

export const StyledLineTwo = styled.div`
  font-family: ${({ theme }) => theme.fonts.title.lineTwo};
  font-size: 1.6em;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    font-size: 0.6em;
  }
`
